<template>
    <div class="animated fadeIn">
        <BaseInventory
            categoryId="10"
            categoryName="Bolt Intake"
            categorySectionIcon="fa-wrench"
        />
    </div>
</template>

<script>
import BaseInventory from './base/BaseInventory'

export default {
    name: 'ball-intake',
    components: { BaseInventory }
}
</script>
